import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../UniformComponents/Button'
import Panel from '../../UniformComponents/Panel'
import Typography from '../../UniformComponents/Typography'
import Switch from '../../UniformComponents/Switch'
import Select from '../form/Select'
import Input from '../form/Input'

const PresentationsForm = ({ store, onStart }) => (
    <div>
        <div style={{ width: '100%', padding: 24, backgroundColor: 'white' }}>
            <Typography type="h2">{i18n.t('presentationbuilder')}</Typography>
        </div>

        <div className="presentations">
            <Panel cssClass="presentations__form">
                <Typography type="h2">New presentation</Typography>

                <br />

                <br />

                <div className="presentations__form-fields">
                    <Input
                        name="entry-title"
                        label="Presentation title *"
                        value={store.entryTitle}
                        onChange={(value) => store.setEntryTitle(value)}
                        placeholder="Enter a title for your presentation"
                    />

                    <Select
                        name="event"
                        label="Event"
                        options={store.eventOptions}
                        value={store.event}
                        onBlur={({ value }) => store.setEvent(value)}
                        placeholder="Select an event"
                    />
                    <Select
                        name="entry-survey"
                        label="Survey type"
                        options={store.entrySurveyOptions}
                        value={store.entrySurvey}
                        onBlur={({ value }) => store.setEntrySurvey(value)}
                        placeholder="Select an entry survey type"
                        showDisabled={!store.event}
                    />
                </div>

                <hr />

                <br />

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <i className="fas fa-lock" style={{ color: '#725AFF' }} />

                            <Typography type="b">{i18n.t('presentation.privacy.title')}</Typography>
                        </div>

                        <Typography type="tiny" color="grey">
                            {i18n.t('presentation.privacy.desc')}
                        </Typography>
                    </div>

                    <Switch onToggle={store.setEntryPrivacy} state={store.entryPrivacy} />
                </div>

                <br />

                <div className="presentations__form-actions">
                    <Button
                        cssClass="regular tertiary"
                        label="Cancel"
                        onClick={store.showLanding}
                    />
                    <Button
                        cssClass="primary regular"
                        label="Start building"
                        onClick={onStart || store.startBuilding}
                        disabled={!store.entrySurvey || !store.entryTitle.length}
                    >
                        <i className="fa-regular fa-arrow-right presentations__cta-arrow" />
                    </Button>
                </div>
            </Panel>
        </div>
    </div>
)

export default observer(PresentationsForm)
